import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Paper, Typography } from "@material-ui/core";

import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import TodayIcon from "@material-ui/icons/Today";

import logo from "../../images/logo.png";
import { Overrides } from "../StyledComponents";
import { brand } from "../StyledComponents/theme";

const MonthStyles = makeStyles({
  item: {
    flex: "1 1 100%",
    padding: "4px",
    textAlign: "center",
  },
});

export default function MonthSummary({ month, numericMonth }) {
  const styles = MonthStyles();

  const classes = Overrides();
  const thisMonth = new Date().getMonth();

  const getMonthName = (month) => {
    return new Intl.DateTimeFormat("en-US", { month: "long" }).format(
      new Date(2000, month, 1)
    );
  };

  const currMonth = getMonthName(thisMonth);
  const isCurrentMonth = month === currMonth;
  const isFutureMonth = numericMonth > thisMonth;
  const isPastMonth = !isCurrentMonth && !isFutureMonth;

  return (
    <Paper
      elevation={isCurrentMonth ? 5 : 0}
      variant={isCurrentMonth ? "elevation" : "outlined"}
      className={isPastMonth ? classes.successBorder : null}
    >
      <Box display="flex" flexDirection="column">
        <div className={styles.item}>
          <Typography variant="h5">{month}</Typography>
        </div>
        <div className={styles.item}>
          {isFutureMonth && <img src={logo} height="32" alt="" />}
          {isCurrentMonth && (
            <TodayIcon style={{ color: brand.navy, fontSize: "32px" }} />
          )}
          {isPastMonth && (
            <AttachMoneyIcon style={{ color: brand.green, fontSize: "32px" }} />
          )}
        </div>
        <div className={styles.item}>
          <Typography variant="body2">
            {isPastMonth ? "Great Job Saving!" : isCurrentMonth ? "Keep Saving!" : "Coming Soon"}
          </Typography>
        </div>
      </Box>
    </Paper>
  );
}
